import { render } from "./padron.vue?vue&type=template&id=1fdcee61"
import script from "./padron.vue?vue&type=script&lang=js"
export * from "./padron.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/NewMov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__